<template>
  <div class="login-form">
    <!-- 登录方式 -->
    <div class="login-methods">
      <span
        style="max-width: 120px"
        :class="currentWayOfLogin === 'password' ? 'active' : ''"
        @click="handleToggle('password')">
        {{ $t('密码登录') }}
      </span>
      <span
        style="min-width: 180px"
        :class="currentWayOfLogin === 'verify-code' ? 'active' : ''"
        @click="handleToggle('verify-code')">
        {{ $t('验证码登录') }}
      </span>
    </div>
    <!-- 客户号与用户号 -->
    <div class="login-id">
      <div class="login-id-box" style="width: 60%;">
        <span>{{ $t('客户号') }}：</span>
        <FormInput
          class="sub-input"
          v-model="customerId"
          :max-length="10"
          :forbid-focus="true"
          :placeholder="$t('请输入')"
          :disabled="appInfo.APP_KEYCODE_CONTROL_ENABLED"
          @blur="handleCustomerIdBlur"
        />
      </div>
      <div class="login-id-box" style="width: 40%;">
        <span>{{ $t('用户号') }}：</span>
        <FormInput
          class="sub-input"
          v-model="userId"
          :max-length="6"
          :forbid-focus="true"
          :placeholder="$t('请输入')"
          :disabled="appInfo.APP_KEYCODE_CONTROL_ENABLED"
          @blur="handleUserIdBlur"
        />
      </div>
    </div>
    <!-- 密码登录 由于在LoginMain中 要读取该组件 所以暂时只能用v-show 不能使用v-if-->
    <PasswordLogin
      ref="passwordLogin"
      v-show="currentWayOfLogin === 'password'"/>
    <!-- 验证码登录 -->
    <VerifyCodeLogin
      ref="verifyCodeLogin"
      v-show="currentWayOfLogin === 'verify-code'"/>
    <BackButton
      @click="handleBack"/>
  </div>
</template>

<script>
import VerifyCodeLogin from './loginMethod/VerifyCodeLogin'
import PasswordLogin from './loginMethod/PasswordLogin'
import { mapState, mapMutations } from 'vuex'
export default {
  components: {
    VerifyCodeLogin,
    PasswordLogin
  },
  data () {
    return {
      // 客户号
      customerId: '',
      // 用户号
      userId: ''
    }
  },
  computed: {
    ...mapState('login', ['currentWayOfLogin', 'userInfo']),
    ...mapState('app', ['appInfo'])
  },
  watch: {
    userInfo: {
      handler (value) {
        const { customerId, userId } = value
        this.customerId = customerId
        this.userId = userId
      },
      // TODO: 如果没开控件的话 这里为false 会好点
      immediate: true
    }
  },
  methods: {
    ...mapMutations('login', ['SET_USER_INFO', 'SET_WAY_OF_LOGIN', 'SET_LOGIN_STATE']),
    handleToggle (way) {
      this.SET_WAY_OF_LOGIN(way)
    },
    handleCustomerIdBlur () {
      const { customerId } = this
      this.SET_USER_INFO({
        customerId
      })
    },
    handleUserIdBlur () {
      const { userId } = this
      this.SET_USER_INFO({
        userId
      })
    },
    handleBack () {
      this.SET_LOGIN_STATE('page-welcome')
    }
  }
}

</script>

<style scoped lang="less">
.login-form {
  width: 100%;
  height: 100%;
  padding: 40px 34px 0;
  overflow: hidden;
  .login-methods {
    text-align: left;
    display: flex;
    align-items: center;
    >span {
      font-size: 18px;
      font-weight: 400;
      word-break: keep-all;
      color: #BBC0D8;
      display: flex;
      align-items: center;
      cursor: pointer;
      &:first-child {
        margin-right: 40px;
      }
    }
    >span.active {
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #131523;
      line-height: 24px;
    }
  }
  .login-id {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #333752;
    line-height: 14px;
    .sub-input {
      // height: 34px;
      padding: 0 2px;
      background: #fff;
      /deep/ .input-box {
        background: #fff;
        input {
          font-size: 14px;
          background: #fff;
        }
      }
    }
    > .login-id-box {
      display: flex;
      align-items: center;
      > span {
        word-break: keep-all;
      }
      &:first-child {
        margin-right: 15px;
      }
    }
  }
}
</style>
